{
  "orgID": 1,
  "name": "Sushi Bento",
  "logoUrl": "https://scontent-lht6-1.xx.fbcdn.net/v/t1.0-1/p200x200/12308773_1736377803259594_7316714305196941498_n.jpg?_nc_cat=0&oh=4a4ec5914a8dcf0868ee1eeb1ddc0dcd&oe=5BF2230D",
  "isSupplier": true,
  "isClient": true,
  "isActive": true,
  "location": "London",
  "companyNumber": "23232",
  "sector": {
    "tagID": 1,
    "type": "industry",
    "tag": "Restaurant"
  },
  "tradingNames": ["Sushi Bento", "Sushi Bento UK Ltd"]
}
